// Local translations
export const T = {
  en_GB: {
    editModel: "Edit Model",
    createModel: "Create Model",
    editModelDescription: "Update the model name and description.",
    createModelDescription:
      "New models start from a template with default fields you can edit afterwards.",
    chooseTemplate: "Template",
    templateStandard: "Standard",
    templateStandardSubtitle: "Income · assets · liabilities · commitments",
    templateStandardDescription:
      "Default income, asset, liability and commitment fields for persons, companies and groups.",
    templateStandardDefaultName: "Standard Financial Situation Model",
    name: "Name",
    namePlaceholder: "e.g., Standard Financial Assessment",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Optional description...",
    language: "Language",
    selectLanguage: "Select language",
    languageCannotBeChanged: "Language cannot be changed after creation",
    nameRequired: "Name is required",
    failedToUpdateModel: "Failed to update model",
    failedToCreateModel: "Failed to create model",
    unexpectedError: "An unexpected error occurred",
    cancel: "Cancel",
    save: "Save",
    create: "Create",
  },
  nb_NO: {
    editModel: "Rediger modell",
    createModel: "Opprett modell",
    editModelDescription: "Oppdater modellens navn og beskrivelse.",
    createModelDescription:
      "Nye modeller starter fra en mal med standardfelt som du kan redigere etterpå.",
    chooseTemplate: "Mal",
    templateStandard: "Standard",
    templateStandardSubtitle: "Inntekter · eiendeler · gjeld · forpliktelser",
    templateStandardDescription:
      "Standard inntekts-, eiendels-, gjelds- og forpliktelsesfelt for personer, selskaper og grupper.",
    templateStandardDefaultName: "Standard økonomisk situasjonsmodell",
    name: "Navn",
    namePlaceholder: "f.eks. Standard økonomisk vurdering",
    descriptionLabel: "Beskrivelse",
    descriptionPlaceholder: "Valgfri beskrivelse...",
    language: "Språk",
    selectLanguage: "Velg språk",
    languageCannotBeChanged: "Språk kan ikke endres etter opprettelse",
    nameRequired: "Navn er påkrevd",
    failedToUpdateModel: "Kunne ikke oppdatere modell",
    failedToCreateModel: "Kunne ikke opprette modell",
    unexpectedError: "En uventet feil oppstod",
    cancel: "Avbryt",
    save: "Lagre",
    create: "Opprett",
  },
} as const;
